import api from '../base';

const NEWSLETTER = '/newsletter/register';
const CONTACT = '/contact';

export default {
  subscribeNewsletter(body) {
    return api.post(NEWSLETTER, body);
  },

  submitContactForm(body) {
    return api.post(CONTACT, body);
  }
};



// WEBPACK FOOTER //
// src/services/contact/service.js